import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ConfirmNoteDialog({ open, onClose, transcription }) {
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      fetchCategories();
    }
  }, [open]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Errore nel caricamento categorie:', error);
    }
  };

  const handleSave = async () => {
    if (!category) {
      toast.error('Seleziona una categoria');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API_URL}/notes`, {
        content: transcription,
        category,
      });
      toast.success('Nota salvata con successo!');
      onClose();
    } catch (error) {
      console.error('Errore nel salvataggio:', error);
      toast.error('Errore nel salvataggio della nota');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Conferma e salva la nota</DialogTitle>
          <DialogDescription>
            Rivedi la trascrizione e scegli in quale categoria salvare.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Trascrizione</Label>
            <div className="p-4 rounded-xl bg-secondary/50 border border-border max-h-60 overflow-y-auto">
              <p className="text-sm whitespace-pre-wrap">{transcription}</p>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="category">Categoria</Label>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger className="h-12" data-testid="category-select">
                <SelectValue placeholder="Seleziona una categoria" />
              </SelectTrigger>
              <SelectContent>
                {categories.map((cat) => (
                  <SelectItem key={cat.name} value={cat.name}>
                    {cat.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
            data-testid="cancel-save-button"
          >
            Annulla
          </Button>
          <Button
            onClick={handleSave}
            disabled={loading}
            className="rounded-full"
            data-testid="save-note-button"
          >
            {loading ? 'Salvataggio...' : 'Salva nota'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}